import React, { useState, useRef } from "react";
import './style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'aos/dist/aos.css';
import banner from '../img/logo/banner-bg.png';
import amogh from '../img/logo/amogh.png'
import arpitha from '../img/logo/arpitha.png'
import top from '../img/logo/left_top.png';
import bottom from '../img/logo/left_bottom.png';
import right_top from '../img/logo/right_top.png';
import right_bottom from '../img/logo/right_bottom.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FiMail, FiPhone } from "react-icons/fi";
import 'react-medium-image-zoom/dist/styles.css';
import Supports from "./Supports";
import Footer from "./Footer";

// Teams

import Karan from '../img/teams/Karan.png';
import Ranganath from '../img/teams/ranganath.png';
import Vishwanath from '../img/teams/Vishwanath.png';
import Vishnukant from '../img/teams/Vishnukant.png';
import Guddushastri from '../img/teams/Guddushastri.png';
import Shailaja from '../img/teams/Shailaja.png';
import Suma from '../img/teams/Suma.png';
import Deepashree from '../img/teams/deepashree.png';
import Indumathi from '../img/teams/Indumathi.png';




function Home() {
 
  
  return (

    
<>
{/* <!-- ======= Start Home Section ======= --> */}
<section id="Home" className="home-bg aos-animate" data-aos="fade-up">
<div className="gap">
<img src={banner} alt="banner" className="logo_icon" width={"200"} />
<h1 className="logo-heading text-center pt-2">AblePro Solutions</h1>
<p className="logo-para text-center pt-1">Enable, Engage, Empower</p>
</div>
</section>
{/* <!-- ======= End Home Section ======= --> */}

    {/* <!-- ======= Start About Section ======= --> */}
    <section  id="About" className="about-bg">
    <img src={right_bottom} alt="banner" className="rightdesign" width={"20%"} />
    <img src={top} alt="banner" className="topdesign" width={"20%"} />
      <Container className="aos-animate" data-aos="fade-up">
        <div className="gap">
        <Row>
        <div className=" aos-animate" data-aos="fade-up" >
      <h1 className="about-heading">Namaste!</h1>
      <p className="about-para pt-3">We are <b>AblePro Solutions Pvt. Ltd.</b>, a startup company registered on September 2024,
with objectives to design, develop, provide, host mobile and web applications and carry on the
business of providing assistive technology services and technology platforms for the disability
sector and conducting research in overcoming everyday challenges of people with disabilities
and set up infrastructures for assistive technology products.</p><br/>
<p className="about-para-last">Our core beliefs with respect to our work —<span>  ‘Enable, Engage, Empower.’</span>  </p>
    </div>
    </Row>
    </div>
      </Container>
    </section>
{/* <!-- ======= End About Section ======= --> */}

{/* <!-- ======= Start Amogh_Inamdar Section ======= --> */}
<section className="home-bg-in">
<img src={bottom} alt="banner" className="bottomdesign" width={"20%"} />
<img src={right_top} alt="banner" className="righttopdesign" width={"20%"} />
  <Container>
  <div className="gap"> 
   <Row > 
      
    <Col lg={4} md={12} sm={12} xs={12} className="aos-animate" data-aos="fade-up">
    <div className="amogh-img">
    <img src={amogh} alt="amogh" style={{ maxWidth: "100%", width: "250px", height: "auto", display: "block", margin: "0 auto" }} />
    <h2 className="amog-heading pt-2">Amogh Inamdar</h2>
    <h4 className="amog-sub-heading">M.Des, IDC, IIT Bombay</h4>
    <p className="amog-para">Founder, Director</p>
    </div>
      </Col>

      <Col lg={8} md={12} sm={12} xs={12} className="aos-animate" data-aos="fade-up">
          <p className="amog-parag pt-1">Life has presented its fair share of challenges, each one shaping my path and deepening my understanding of what truly matters. These experiences inspired a vision—to create a platform that not only offers practical solutions but also builds connection, support, and strength within our community. <br /><br />
I never set out to build a company. What guided me was a simple but powerful desire to do something meaningful. A professor at IIT Bombay once said, “It’s easy to make money, but the same can’t be said of making meaning in your life.” Those words have stayed with me, and they continue to guide this journey.<br /><br />
This platform is my way of making meaning—by listening with care, responding with purpose, and working toward a future that’s more inclusive, more empowering, and more compassionate. It’s a mission that’s deeply personal, shaped by my own experiences as a person with a hearing impairment.</p>
       
        </Col>
      </Row>
      </div>
  </Container>

  <Container fluid id="Contact" className="middle_line"></Container>
  <Container>
  <div className="gap"> 
   <Row > 
      
    <Col lg={4} md={12} sm={12} xs={12} className="aos-animate" data-aos="fade-up">
    <div className="amogh-img">
    <img src={arpitha} alt="arpitha" style={{ maxWidth: "100%", width: "250px", height: "auto", display: "block", margin: "0 auto" }} />
    <h2 className="amog-heading pt-2">Dr. Arpitha Vasudevmurthy</h2>
    <h4 className="amog-sub-heading">MSc. SLP and PhD. Human Communication, Language and Development</h4>
    <p className="amog-para">Co-Founder, Director</p>
    </div>
      </Col>

      <Col lg={8} md={12} sm={12} xs={12} className="aos-animate" data-aos="fade-up">
          <p className="amog-parag pt-1">Living with dyslexia&mdash;a difficulty in learning to read and spell&mdash;has been both demanding and deeply rewarding. The challenges I faced sparked a lifelong curiosity: why do some children struggle to acquire language and literacy skills, and how can we better support them? This quest became the foundation of my professional path, dedicated to helping children and individuals with learning difficulties thrive.<br /><br />
One belief continues to guide my work: every child learns differently, and many hidden struggles go unnoticed or misunderstood by parents and educators. But when learning becomes more engaging and less overwhelming, we give children something powerful&mdash;hope and confidence&mdash;the tools they need to succeed, even in the face of adversity.<br /><br />
The foundation of this company lies in the combination of personal experience transformed into a professional mission to make a difference. My mission is to raise awareness about communication disorders and to build evidence-based, technology-driven solutions that make learning enjoyable and effective for every individual with special needs. From research and resource development to designing targeted training materials and delivering specialized services, every effort is rooted in the desire to create real, lasting impact.<br /><br />
In short, we believe that understanding what challenges exist is the first step toward discovering how to engage and empower learners, bringing knowledge, empathy, and innovation together to address real-world difficulties of persons with disabilities.
</p>
       
        </Col>
      </Row>
      </div>
  </Container>


</section>
{/* <!-- End Amogh_Inamdar Section --> */}




{/* <!-- Start Our Team Section --> */}
<section id="Team" className="about-bg gap-contact" >
<img src={top} alt="banner" className="topdesign" width={"20%"} />
<img src={right_bottom} alt="banner" className="rightbottomdesign" width={"20%"} />
<Container className="gap aos-animate" data-aos="fade-up">
 <h1 className="our_team_heading" >Our Team</h1>
<Row>
    <Col xs={6} sm={6} md={6} lg={{span:2, offset:1}}>
        <div className="our_team_cont">
     <img src={Karan} alt="our team" className="ourteam_effect" width={"100%"} />
     <h5 className="ourteam-heading pt-4">Karan Kumar</h5>
     <p className="ourteam-sub-heading pb-3">Investor, Business Coach</p>
     </div>
        </Col>
        <Col xs={6} sm={6} md={6} lg={2}>
        <div className="our_team_cont">
     <img src={Ranganath} alt="our team" className="ourteam_effect" width={"100%"} />
     <h5 className="ourteam-heading pt-4">Ranganath Sadasiva</h5>
     <p className="ourteam-sub-heading pb-3">Chief Technology Mentor</p>
     </div>
        </Col>
        <Col xs={6} sm={6} md={6} lg={2}>
        <div className="our_team_cont">
     <img src={Vishwanath} alt="our team" className="ourteam_effect" width={"100%"} />
     <h5 className="ourteam-heading pt-4">Vishwanath Rumale</h5>
     <p className="ourteam-sub-heading pb-3">Technology Partner, IGS India</p>
     </div>
        </Col>
        <Col xs={6} sm={6} md={6} lg={2}>
        <div className="our_team_cont">
     <img src={Vishnukant} alt="our team" className="ourteam_effect" width={"100%"} />
     <h5 className="ourteam-heading pt-4">Dr. Vishnukant Chatpalli</h5>
     <p className="ourteam-sub-heading pb-3">Chief Advisor</p>
     </div>
        </Col>
        <Col xs={6} sm={6} md={6} lg={{span:2, offset:-1}}>
        <div className="our_team_cont">
          <img src={Guddushastri} alt="our team" className="ourteam_effect" width={"100%"} />
          <h5 className="ourteam-heading pt-4">G. M Inamdar</h5>
          <p className="ourteam-sub-heading pb-3">Managing Director</p>
          </div>
        </Col>
        <Col xs={6} sm={6} md={6} lg={{span:2, offset: 2}}>
        <div className="our_team_cont">
          <img src={Indumathi} alt="our team" className="ourteam_effect" width={"100%"} />
          <h5 className="ourteam-heading pt-4">Dr. Indumathi Rao</h5>
          <p className="ourteam-sub-heading pb-3">Social Impact Advisor</p>
          </div>
        </Col>
        <Col xs={6} sm={6} md={6} lg={2}>
        <div className="our_team_cont">
          <img src={Shailaja} alt="our team" className="ourteam_effect" width={"100%"} />
          <h5 className="ourteam-heading pt-4">Shailaja Inamdar</h5>
          <p className="ourteam-sub-heading pb-3">Product Guide</p>
          </div>
        </Col>
        <Col xs={6} sm={6} md={6} lg={2}>
        <div className="our_team_cont">
          <img src={Suma} alt="our team" className="ourteam_effect" width={"100%"} />
          <h5 className="ourteam-heading pt-4">Dr. H N Suma</h5>
          <p className="ourteam-sub-heading pb-3">Director, BIG Foundation</p>
          </div>
        </Col>
        <Col xs={{span:6, offset:3}} sm={6} md={6} lg={{span:2, offset:0}}>
        <div className="our_team_cont">
          <img src={Deepashree} alt="our team" className="ourteam_effect" width={"100%"} />
          <h5 className="ourteam-heading pt-4">Dr. Deepashree S R</h5>
          <p className="ourteam-sub-heading pb-3">Domain Expert Advisor</p>
          </div>
        </Col>
        
        
        
      </Row>
      </Container>
    </section>

    <Supports></Supports>
    {/* <!-- End Our Team Section --> */}
    <Container fluid id="Contact" className="middle_line"></Container>
    {/* <!-- ======= Start Contact Section ======= --> */}
    <section className="home-bg-in" >
    {/* <img src={bottom} alt="banner" className="bottomdesign" width={"20%"} /> */}
    <img src={right_top} alt="banner" className="righttopdesign" width={"20%"} />
      <div className="gap" >
        <div className="reach-contner aos-animate" data-aos="fade-up">
        <h1 className="reach-heading pb-3">Reach us at</h1>
        <p className="reach-para-mail"><a href="mailto:ai@ableproindia.com">
        <span><FiMail /></span>&nbsp;<span className="email-style">ai@ableproindia.com</span></a></p>
        <p className="reach-para"><FiPhone />&nbsp;<a href="tel:98441 32652">+91 98441 32652</a> | <a href="tel:97395 50801"> +91 97395 50801</a></p>
        </div>
      </div>
    </section>
{/* <!-- ======= Start Contact Section ======= --> */}

{/* <!-- ======= Start footer_logo Section ======= --> */}
<section className="about-bg">
<img src={top} alt="banner" className="lefttdesign" width={"20%"} />
<img src={right_bottom} alt="banner" className="rightbottomdesign" width={"20%"} />
<div className="gap">
<div className="reach-cont " >
<img src={banner} alt="banner" className="logo_icon" width={"200"} />
<h1 className="footer-heading text-center pt-5">AblePro Solutions</h1>
<p className="footer-para text-center pt-3">Enable, Engage, Empower</p>
</div>
</div>
</section>
{/* <!-- ======= End footer_logo Section ======= --> */}

<Footer></Footer>

  </>
  )
}

export default Home
